import React, { useState, useCallback } from 'react'
// import _get from 'lodash/get'
import { Stack, Grid } from '@mui/material'
import {
  // BooleanInput,
  DateTimeInput,
  required,
  TextInput,
  useEditContext,
  Loading,
  // useTranslate,
  FormTab,
  useLocaleState,
  TransformData,
} from 'react-admin'
import dayjs from 'dayjs'
import { isAfterDate, isBeforeDate, isSameDate } from '../../utils/validators'
import { TabbedMultiCardForm } from '../../components/tab'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'
import { CreateBase } from '../../components/base'
import {
  PublishPeriodInputsProps,
  // EditApplyEnglishButtonProps,
} from './type'
import { ApproveAndPublishToolBar } from '../../components/form'
import { COMMON_FIELDS, JOB_OPPORTUNITIES_FIELDS } from '../../providers/localization/constant'
import { MyRichTextInput } from '../../components/text-editor'
// import { ImageInput, MultipleFileInput } from '../../components/inputs'
import ApplyToEnglishButton from '../../components/buttons/ApplyToEnglishButton'
import sanitizeHtml from 'sanitize-html'
import unescape from 'lodash/unescape'

const PublishPeriodInputs: React.FC<PublishPeriodInputsProps> = ({ isApproved = false }) => {
  const defaultPublishDate = dayjs()
  const defaultExpiredDate = defaultPublishDate.add(2, 'day')

  return (
    <>
      <DateTimeInput
        source='start_date'
        label={`${COMMON_FIELDS}.date.published_on`}
        disabled={isApproved}
        fullWidth
        defaultValue={defaultPublishDate}
        validate={[
          required(),
          isBeforeDate('end_date', 'The publish date must be in before the expired date.'),
        ]}
      />
      <DateTimeInput
        source='end_date'
        disabled={isApproved}
        label={`${COMMON_FIELDS}.date.expired_on`}
        fullWidth
        defaultValue={defaultExpiredDate}
        validate={[
          required(),
          isAfterDate('start_date', 'The expired date must be in after the publish date.'),
          !isApproved ? isSameDate() : null,
        ]}
      />
    </>
  )
}

// const EditApply: React.FC<EditApplyEnglishButtonProps> = ({ isApproved, updateKeyEditor }) => {
//   return !isApproved ? (
//     <Grid item xs={12}>
//       <ApplyToEnglishButton updateKeyEditor={updateKeyEditor} />
//     </Grid>
//   ) : (
//     <></>
//   )
// }

const PersistForm: React.FC<{ preventEdit: boolean }> = ({ preventEdit = false }) => {
  const [activeLocale] = useLocaleState()
  // const { record } = useEditContext()

  return (
    <Grid container spacing={2}>
      {/* <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <NewsTypeSelectInput disabled={preventEdit} />
          </Grid>
          <Grid item xs={6}>
            <NewsPublishCondSelectInput disabled={preventEdit} />
          </Grid>
        </Grid>
      </Grid> */}
      {/* <Grid item xs={12}>
        <Grid container spacing={2}>
          <FilterTypeProjectAutocompleteArrayInput
            source='property_ids'
            depField='publish_condition'
            expectedValue='s'
            label='Select Project'
            disabled={preventEdit}
          />
        </Grid>
      </Grid>  */}
      <Grid item xs={12} order={{ xs: -1, sm: 0 }}>
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <NewsDeepLinkInput disabled={preventEdit} buttonProps={{ sx: { mt: 0.5 } }} />
          </Grid> */}
          {/* <Grid item xs={6}>
            <TextInput
              source='branch'
              label={`${JOB_OPPORTUNITIES_FIELDS}.branch`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              disabled={preventEdit}
            />
          </Grid> */}
          <Grid item xs={6}>
            <TextInput
              source='number'
              label={`${JOB_OPPORTUNITIES_FIELDS}.number`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              disabled={preventEdit}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack spacing={2} direction={{ xs: 'column', md: 'row' }}>
              <PublishPeriodInputs isApproved={preventEdit} />
            </Stack>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput
              source='apply_link'
              label='Apply Link'
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              disabled={preventEdit}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <ModifyTimeStamp language={activeLocale} />
      </Grid>
    </Grid>
  )
}

const CreateForm: React.FC = () => {
  const { record, isLoading } = useEditContext()
  const [editorContentEnKey, setEditorContentEnKey] = useState(0)
  const isApproved: boolean = record?.is_approved
  const isPublished: boolean = record?.is_published
  const preventEdit = isPublished || isApproved
  const reloadTextEditor = (): void => {
    setEditorContentEnKey(editorContentEnKey + 1)
  }
  if (isLoading) return <Loading />

  return (
    <TabbedMultiCardForm
      formProps={{
        toolbar: null,
        toolbarBottom: <ApproveAndPublishToolBar encType='application/json' />,
      }}
      childrenForms={[<PersistForm key='' preventEdit={preventEdit} />]}
    >
      <FormTab label='TH'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput
              source='title_th'
              label={`${JOB_OPPORTUNITIES_FIELDS}.title_th`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              source='branch_th'
              label={`${JOB_OPPORTUNITIES_FIELDS}.branch_th`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              source='experience_th'
              label={`${JOB_OPPORTUNITIES_FIELDS}.experience_th`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={12}>
            <MyRichTextInput
              fullWidth
              label={`${JOB_OPPORTUNITIES_FIELDS}.description_th`}
              source='description_th'
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <ApplyToEnglishButton updateKeyEditor={reloadTextEditor} />
        </Grid>
      </FormTab>
      <FormTab label='EN'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput
              source='title_en'
              label={`${JOB_OPPORTUNITIES_FIELDS}.title_en`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              source='branch_en'
              label={`${JOB_OPPORTUNITIES_FIELDS}.branch_en`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              source='experience_en'
              label={`${JOB_OPPORTUNITIES_FIELDS}.experience_en`}
              InputProps={{
                fullWidth: true,
              }}
              fullWidth
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
          <Grid item xs={12}>
            <MyRichTextInput
              fullWidth
              label={`${JOB_OPPORTUNITIES_FIELDS}.description_en`}
              source='description_en'
              validate={[required()]}
              // disabled={preventEdit}
            />
          </Grid>
        </Grid>
      </FormTab>
    </TabbedMultiCardForm>
  )
}

const JobOpportunityCreate: React.FC = () => {
  const transform: TransformData = useCallback((data) => {
    return {
      ...data,
      title_th: sanitizeHtml(unescape(data.title_th)),
      title_en: sanitizeHtml(unescape(data.title_en)),
      short_description_th: sanitizeHtml(unescape(data.short_description_th)),
      short_description_en: sanitizeHtml(unescape(data.short_description_en)),
      description_th: sanitizeHtml(unescape(data.description_th)),
      description_en: sanitizeHtml(unescape(data.description_en)),
    }
  }, [])
  return (
    <CreateBase
      title={`${JOB_OPPORTUNITIES_FIELDS}.create.title`}
      listAction={{
        hasBackButton: true,
      }}
      noCard
      encType='application/json'
      transform={transform}
    >
      <CreateForm />
    </CreateBase>
  )
}

export default JobOpportunityCreate
